import { toast } from 'react-toastify';
import { constants } from '../shared/constants';
import { session } from '../Service/APIService';
import { clientsSpecificTabsAccess } from '../shared/tabsConstants';

const floatRegExp = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);

export const parseQueryString = (url) => {
  const urlParams = {};
  url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), ($0, $1, $2, $3) => {
    urlParams[$1] = $3;
  });

  return urlParams;
};

export const generateURL = () =>
  window._env_ && window._env_.REACT_APP_API_URL
    ? window._env_.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL;

export const checkDDL = () =>
  // eslint-disable-next-line
    window._env_ && window._env_.REACT_APP_SHOW_DDL ? eval(window._env_.REACT_APP_SHOW_DDL) : eval(process.env.REACT_APP_SHOW_DDL);

export const minutesWithLeadingZero = (dt) =>
  (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes();

export const validateAPEPDCLClient = () => {
  const userObj = session.user();
  return userObj.clientname === 'APEPDCL';
};

export const powerbireportId = () =>
  window._env_ && window._env_.REACT_APP_POWER_BI_REPORT_ID
    ? window._env_.REACT_APP_POWER_BI_REPORT_ID
    : process.env.REACT_APP_POWER_BI_REPORT_ID;

export const powerbireportURL = () =>
  window._env_ && window._env_.REACT_APP_POWER_BI_EMBEDED_URL
    ? window._env_.REACT_APP_POWER_BI_EMBEDED_URL
    : process.env.REACT_APP_POWER_BI_EMBEDED_URL;

export const getGoogleMapApiKey = () =>
  window._env_ && window._env_.REACT_APP_GOOGLE_MAP_API_KEY
    ? window._env_.REACT_APP_GOOGLE_MAP_API_KEY
    : process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const getWebsocketURL = () =>
  window._env_ && window._env_.REACT_APP_WEB_SOCKET_URL
    ? window._env_.REACT_APP_WEB_SOCKET_URL
    : process.env.REACT_APP_WEB_SOCKET_URL;

export const getAnalogLogIntervaltime = () =>
  window._env_ && window._env_.REACT_APP_ANALOG_LOG_REFRESH_INTERVAL
    ? window._env_.REACT_APP_ANALOG_LOG_REFRESH_INTERVAL
    : process.env.REACT_APP_ANALOG_LOG_REFRESH_INTERVAL || 60;

export const getSLDAIIntervalTime = () =>
  window._env_ && window._env_.REACT_APP_SLD_REFRESH_INTERVAL_AI
    ? window._env_.REACT_APP_SLD_REFRESH_INTERVAL_AI
    : process.env.REACT_APP_SLD_REFRESH_INTERVAL_AI || 40;

export const getSLDDIIntervalTime = () =>
  window._env_ && window._env_.REACT_APP_SLD_REFRESH_INTERVAL_DI
    ? window._env_.REACT_APP_SLD_REFRESH_INTERVAL_DI
    : process.env.REACT_APP_SLD_REFRESH_INTERVAL_DI || 20;

export const getSA30URL = () =>
  window._env_ && window._env_.REACT_APP_EMBED_URL
    ? window._env_.REACT_APP_EMBED_URL
    : process.env.REACT_APP_EMBED_URL;

export const chartObjectCreator = async (chrt) => {
  const chart = {
    chart: {
      renderTo: chrt.chart.renderTo,
      type: chrt?.chart?.type || 'line',
      height: chrt?.chart?.height,
    },
    title: {
      text: chrt?.title?.text || '',
    },
    subtitle: {
      text: chrt?.subtitle?.text || '',
    },
    yAxis: chrt?.yAxis,
    xAxis: chrt?.xAxis,
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
        fontWeight: 'normal',
      },
    },
    plotOptions: chrt?.plotOptions,
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: [
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
            'separator',
            'downloadCSV',
            'downloadXLS',
            'viewData',
          ],
        },
      },
    },
    scrollbar: {
      enabled: false,
    },
    rangeSelector: {
      selected: 2,
      inputEnabled: false,
    },
    credits: {
      enabled: false,
    },
    navigator: {
      enabled: false,
    },
    tooltip: {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
      valueDecimals: 2,
      split: true,
    },
    series: chrt.series || [],
    lang: {
      noData: constants.core.EMPTY_CHART_MSG,
    },
    noData: {
      position: {
        x: 0,
        y: 0,
        align: 'center',
        verticalAlign: 'middle',
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              enabled: false,
            },
          },
        },
      ],
    },
  };
  return chart;
};

export const getHirarchyValues = (role) => {
  switch (role) {
    case 'ClientAdmin':
      return ['clientId', 'Circle'];
    case 'CircleAdmin':
      return ['circleId', 'Division'];
    case 'DivisionAdmin':
      return ['divisionId', 'Town'];
    case 'TownAdmin':
      return ['townId', 'Sub Division'];
    case 'SubdivisionAdmin':
      return ['subDivisionId', 'Section'];
    case 'SectionAdmin':
      return ['sectionId', 'Sub Station'];
    case 'SubstationAdmin':
      return ['substationId', 'Asset'];
    default:
      return ['clientId', 'Circle'];
  }
};

export const showToast = (msg, type) => {
  if (!type) {
    toast.success(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  } else {
    toast.error(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }
};

export const ResizeElements = (type) => {
  if (type === 'SLD') return;
  const w1 = document.getElementById(type === 'MAP' ? 'widget1' : 'widget2');
  // eslint-disable-next-line no-nested-ternary
  w1.className = document
    .getElementById(type === 'MAP' ? 'widget1' : 'widget2')
    .classList.contains(type === 'MAP' ? 'col-lg-5' : 'col-lg-7')
    ? 'col-lg-12'
    : type === 'MAP'
    ? 'col-lg-5'
    : 'col-lg-7';

  const widget1 = document.getElementById('widget1');
  const widget2 = document.getElementById('widget2');
  const dv1 = document.getElementById('dv1');
  const dv2 = document.getElementById('dv2');
  if (dv1.firstChild !== null) {
    dv1.removeChild(dv1.firstChild);
  }
  if (dv2.firstChild !== null) {
    dv2.removeChild(dv2.firstChild);
  }

  const obj = {
    w1Size: widget1.classList.contains('col-lg-12') ? 12 : 5,
    w2Size: widget2.classList.contains('col-lg-12') ? 12 : 7,
  };

  switch (type) {
    case 'MAP':
      if (obj.w1Size === 12) {
        dv1.appendChild(widget1);
        dv2.appendChild(widget2);
      } else if (obj.w2Size === 12) {
        dv1.appendChild(widget2);
        dv2.appendChild(widget1);
      } else {
        dv1.appendChild(widget1);
        dv2.appendChild(widget2);
      }
      break;
    case 'TABLE':
      if (obj.w2Size === 12) {
        dv1.appendChild(widget2);
        dv2.appendChild(widget1);
      } else if (obj.w1Size === 12) {
        dv1.appendChild(widget1);
        dv2.appendChild(widget2);
      } else {
        dv1.appendChild(widget1);
        dv2.appendChild(widget2);
      }
      break;
    default:
      break;
  }

  window.scroll(0, 0);
  return obj;
};

export const makeFullScreen = () => {
  if (!document.fullscreen) {
    document.documentElement.requestFullscreen();
  } else {
    document.exitFullscreen();
  }
};

export const checkDecimalRegExp = (value) => {
  return floatRegExp.test(value);
};

// checks individually for tab access
const checkRoleWiseTabAccess = async (list, appName, pageName, tabName) => {
  const tabDetails = list.find(
    (item) =>
      item.appName === appName &&
      item.tabName === pageName &&
      item.viewName === tabName
  );
  return await !!tabDetails;
};

// check client wise access extract the matching key from const and if
// value is matched then return key value else return true as access exist
export const checkClientWiseTabAccess = (tabName) => {
  const userInfo = session.user();
  const userAccessTabKeyFlagName = clientsSpecificTabsAccess[tabName];
  if (userAccessTabKeyFlagName) {
    return userInfo[userAccessTabKeyFlagName];
  }
  return true;
};

// checks received tab list array for tab access
export const checkTabAccess = async (
  list,
  appName,
  pageName,
  originalTabObject
) => {
  if (!list || !list?.length) {
    return { tabAccessList: {}, defaultActiveKey: 0, tabSequenceList: {} };
  }

  let defaultActiveKey = null;
  let minSequenceNumber = Infinity;
  const tabAccessList = {};
  const tabSequenceList = {};

  const accessPromises = originalTabObject.map(async (item) => {
    const isAccess = await checkRoleWiseTabAccess(
      list,
      appName,
      pageName,
      item.name
    );
    const clientWiseAccess = checkClientWiseTabAccess(item.name);

    tabAccessList[item.name] = isAccess;
    tabSequenceList[item.name] = item.tabKey;

    if (isAccess) {
      if (!clientWiseAccess) {
        tabAccessList[item.name] = false;
      } else if (item.tabSequenceNumber < minSequenceNumber) {
        minSequenceNumber = item.tabSequenceNumber;
        defaultActiveKey = item.tabKey;
      }
    }
  });

  await Promise.all(accessPromises);

  return { tabAccessList, defaultActiveKey, tabSequenceList };
};

export const createTabWiseSequenceOrderObject = (tabsList, tabsToExclude) => {
  const Obj = [];
  tabsList.forEach((tab) => {
    if (!tabsToExclude.includes(tab.name)) {
      Obj.push(tab);
    }
  });
  return Obj;
};

export const checkTabAccessForAnalytics = async (
  list,
  appName,
  pageName = 'Analytics',
  originalTabObject
) => {
  if (!list || !list.length) {
    return { tabAccessList: [] };
  }

  const accessPromises = originalTabObject.map(async (item) => {
    const isAccess = await checkRoleWiseTabAccess(
      list,
      appName,
      pageName,
      item
    );
    if (isAccess && checkClientWiseTabAccess(item)) {
      return item;
    }
    return null;
  });

  const tabAccessList = (await Promise.all(accessPromises)).filter(
    (item) => item !== null
  );

  return { tabAccessList };
};

export const renderDefaultImage = () => {
  //GREY
  return '/Images/IEEE1975/Double_Point_Circuit_Breaker_Open_vt_raw_IEE75_hz.png';
};
